
import React, { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'
import Portal from '../Portal'
import Icon from '../Icon'
import { Mask } from 'antd-mobile'
import './index.scss'

const _iconStyle = { fontSize: '.373333rem', color: '#333', transform: 'rotate(180deg)' }

export interface Action {
    text: string
    key: any
    disabled?: boolean
}
export interface ActionSheetProps {
    visible: boolean
    actions: Action[]
    title?: string
    current?: any
    multiple?: boolean // 是否支持多选
    onCancel?: () => void // 确定按钮的回调
    onChange?: (index, item?) => void // 确定按钮的回调
    isCancelBtn?: boolean
}
export class ActionSheet extends React.Component<ActionSheetProps, any> {

    el: any = React.createRef()
    itemEl: any = React.createRef()

    static defaultProps = {
        visible: true,
        onCancel: () => { },
        actions: [],
        isCancelBtn: false
    }

    constructor(props: ActionSheetProps) {
        super(props)

        this.state = {
            current: props.current || (props.multiple ? [] : null)
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(this.props.multiple && this.props.current.join('') !== prevProps.current.join('')) {
            this.setState({
                current: [...this.props.current]
            })
        }
    }

    render() {
        const { visible, actions, title, isCancelBtn, multiple } = this.props
        const _current = multiple ? this.state.current : this.props.current

        return <Mask destroyOnClose visible={visible} onMaskClick={this.handleCancel.bind(this)} style={{'--z-index': '999999999'}}>
            <div className={`action-sheet-wrapper ${visible ? 'fade_in' : 'fade_out'} `}>
                {title && <div className='action-sheet-wrapper-title'>
                    {isCancelBtn && <div className='action-sheet-wrapper-cancel' onClick={this.handleCancel.bind(this)}>取消</div>}
                    <div>{title}</div>
                    {multiple && <div className='action-sheet-wrapper-confirm' onClick={this.handleConfirm.bind(this)}>确定</div>}
                </div>}
                <div style={{ maxHeight: '70vh', overflowX: 'hidden', overflowY: 'auto' }} ref={this.el}>
                    {actions.map((item, index) => {
                        const isCurrent = multiple ? _current.includes(item.key) : (_current === index || _current === item.text || _current === item.key)
                        return (
                            <div className='action-sheet-wrapper-item' ref={this.itemEl} key={index} onClick={this.handleChangeItem.bind(this, index, item)}>
                                <div>{item.text}</div>
                                <p>{isCurrent && <Icon icon={ !multiple ? '&#xe60a;' : '&#xe75c;'} style={{'fontSize:':multiple ? '.4267rem' : ''}} />}</p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </Mask>
    }

    handleCancel() {
        if (this.props.onCancel) {
            this.props.onCancel()
        }
    }

    handleChangeItem(index, item) {
        if (this.props.onChange && !this.props.multiple) {
            this.props.onChange(index, item)
        }
        if(this.props.multiple) {
            const i = this.state.current.findIndex(o => o === item.key)

            if(i === -1) {
                this.setState({
                    current: [...this.state.current, item.key]
                })
            }else {
                this.setState({
                    current: [...this.state.current.slice(0, i), ...this.state.current.slice(i + 1)]
                })
            }
        }
    }

    // 确认选择
    handleConfirm() {
        if (this.props.onChange && this.props.multiple) {
            const _current = this.props.actions.reduce((t, c) => {
                if(this.state.current.includes(c.key)) {
                    return [...t, c.key]
                }
                return t
            }, [])
            this.props.onChange(_current)
        }
    }

    componentDidMount() {
        const offsetHeight = this.itemEl?.current?.offsetHeight
        const { actions, current } = this.props
        if (current && actions.length && offsetHeight && this.el?.current) {
            const len = actions.findIndex((item, index) => index === current || current === item.text);
            if (len > 8) {
                this.el.current.scrollTop = len * offsetHeight
            }
        }
    }
}

export default ActionSheet

export interface ActionSheetShowProps {
    title?: string
    actions: Action[]
    current?: number | string
    autoDestroy?: boolean // 是否路由切换自动销毁
    onCancel?: () => void // 确定按钮的回调
    onChange?: (index, item) => void // 确定按钮的回调
}

export const ActionSheetShow = (options: ActionSheetShowProps) => {

    const _div = document.getElementById('action-sheet-id')
    if (_div) {
        ReactDOM.render(null, _div)
        document.body.removeChild(_div)
    }
    let div = document.createElement('div')
    div.id = 'action-sheet-id'
    document.body.appendChild(div);

    // 销毁
    const destroy = () => {
        ReactDOM.render(null, div)
        document.body.removeChild(div)
    }

    const ActionSheetHook = (props) => {
        const [visible, setVisible] = useState(true)
        const onCancel = () => setVisible(false)
        const onChange = async (index, item) => {
            try {
                const data = await options.onChange(index, item)
                setVisible(false)
            } catch (error) {
                setVisible(false)
            }
        }
        return <Portal><ActionSheet visible={visible} {...options} onCancel={onCancel} onChange={onChange} /></Portal>
    }

    ReactDOM.render(<ActionSheetHook />, div)
}

ActionSheetShow.destroy = () => {
    const div = document.getElementById('action-sheet-id')
    if (div) {
        ReactDOM.render(null, div)
        document.body.removeChild(div)
    }
}

